import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import { GetPageContentBySlug } from '../services/apiservice';
import { useLocation } from 'react-router-dom';

const RegexTester = () => {
  const [pattern, setPattern] = useState('');
  const [testString, setTestString] = useState('');
  const [matches, setMatches] = useState([]);
  const [error, setError] = useState('');
  const [pageContent, setPageContent] = useState('');
  const location = useLocation();

  const paramlink = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    setPattern('');
    setTestString('');
    setMatches([]);
    setError('');
    fetchPageContent();
  }, []);

  const fetchPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setPageContent(jsonMetaList);
        console.log(jsonMetaList);
      } catch (err) {
        console.error('Error fetching page content:', err);
      }
    }
  };

  const handleTest = () => {
    if (!pattern.trim()) {
      setError('Please enter a regex pattern');
      setMatches([]);
      return;
    }
    if (!testString.trim()) {
      setError('Please enter a test string');
      setMatches([]);
      return;
    }

    try {
      const regex = new RegExp(pattern, 'g'); // global match
      const result = testString.match(regex);
      setMatches(result || []);
      setError('');
    } catch (e) {
      setError('Invalid Regex Pattern');
      setMatches([]);
    }
  };

  const handleClear = () => {
    setPattern('');
    setTestString('');
    setMatches([]);
    setError('');
  };

  return (
    <>
      <Header />


      <RandomContent />

      {/* Page Intro (Section 1) */}
      <div className="blog-area">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              <div
                className="single-blog-inner shadow-sm p-4 mb-4"
                data-aos="fade-up"
                data-aos-duration="2800"
              >
                <div className="details">
                  <h4>
                    <a href="#">{pageContent?.section1header}</a>
                  </h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        pageContent?.section1text && pageContent.section1text.trim() !== ""
                          ? pageContent.section1text
                          : `                    Test your regular expressions online! Enter a pattern and a test string to see all matches. Format your regex and validate input quickly. 🚀`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Regex Tester Section */}
      <div className="blog-area pb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-8 col-md-10">
              <div
                className="single-blog-inner p-5 shadow-sm rounded-lg"
                data-aos="fade-up"
                data-aos-duration="2800"
              >
                {/* Regex Pattern Input */}
                <div className="mb-3">
                  <label className="form-label">Regex Pattern</label>
                  <input
                    type="text"
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    value={pattern}
                    placeholder="Enter regex pattern"
                    onChange={(e) => { setPattern(e.target.value); setError(''); }}
                  />
                </div>

                {/* Test String Input */}
                <div className="mb-3">
                  <label className="form-label">Test String</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Enter text to test"
                    value={testString}
                    onChange={(e) => setTestString(e.target.value)}
                  />
                </div>

                {/* Buttons */}
                <div className="d-flex gap-2 mb-3">
                  <button className="default-btn icon four" onClick={handleTest}>
                    Test Regex
                  </button>
                  <button className="default-btn icon outline" onClick={handleClear}>
                    Clear
                  </button>
                </div>

                {/* Error Message */}
                {error && <div className="text-danger mb-3">{error}</div>}

                {/* Matches Output */}
                {matches.length > 0 && (
                  <div className="result-box p-3 rounded shadow-sm" style={{ backgroundColor: '#f5f5f5' }}>
                    <h6>Matches:</h6>
                    <ul>
                      {matches.map((m, i) => (
                        <li key={i}>{m}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {matches.length === 0 && !error && testString && (
                  <div className="result-box p-3 rounded shadow-sm" style={{ backgroundColor: '#f5f5f5' }}>
                    <h6>No matches found.</h6>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 Below Boxes */}
      {pageContent?.section2text && pageContent.section2text.trim() !== "" && (
        <div className="blog-area">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                  <div className="details">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: pageContent.section2text,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Section 3 Below Boxes */}
      {pageContent?.section3text &&
        pageContent.section3text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section3text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      <Footer />

      <style jsx>{`
        .form-label {
          font-weight: 600;
          margin-bottom: 5px;
        }
        .result-box h6 {
          margin-bottom: 5px;
        }
        .d-flex button {
          flex: 1;
        }
        @media(max-width: 576px) {
          .d-flex {
            flex-direction: column !important;
          }
          .d-flex button {
            margin-bottom: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default RegexTester;
